export default {
  name: 'ActivePointSkeletonComponent',
  template: `
    <div class="partners-map-point__skeleton">
      <div class="partners-map-point__skeleton-title">
        <span class="partners-map-point__skeleton-line partners-map-point__skeleton-line--wide"></span>
        <span class="partners-map-point__skeleton-line partners-map-point__skeleton-line--medium"></span>
      </div>
      <div class="partners-map-point__skeleton-achievements">
        <span class="partners-map-point__skeleton-line partners-map-point__skeleton-line--narrow"></span>
        <div class="partners-map-point__skeleton-icons">
          <span class="partners-map-point__skeleton-icon"></span>
          <span class="partners-map-point__skeleton-icon"></span>
        </div>
      </div>
      <div class="partners-map-point__skeleton-section">
        <span class="partners-map-point__skeleton-line partners-map-point__skeleton-line--wide"></span>
        <span class="partners-map-point__skeleton-line partners-map-point__skeleton-line--medium"></span>
        <div class="partners-map-point__skeleton-row">
          <span class="partners-map-point__skeleton-line partners-map-point__skeleton-line--narrow"></span>
          <span class="partners-map-point__skeleton-line partners-map-point__skeleton-line--narrow"></span>
        </div>
        <div class="partners-map-point__skeleton-row">
          <span class="partners-map-point__skeleton-line partners-map-point__skeleton-line--narrow"></span>
          <span class="partners-map-point__skeleton-line partners-map-point__skeleton-line--narrow"></span>
        </div>
      </div>
      <span class="partners-map-point__skeleton-btn"></span>
    </div>
  `,
}
